import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "w-full" };
const _hoisted_2 = { class: "flex items-center gap-2" };
const _hoisted_3 = {
    key: 0,
    class: "flex flex-col gap-1"
};
const _hoisted_4 = {
    key: 1,
    class: "flex items-center gap-2"
};
const _hoisted_5 = { class: "flex flex-col gap-1" };
const _hoisted_6 = { class: "title" };
const _hoisted_7 = { class: "subtitle" };
import UAvatar from "@/components/uikit/uComponents/UAvatar.vue";
import { computed, onMounted, ref } from "vue";
import { useStore } from "vuex";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ProjectOwnerInfo',
    setup(__props) {
        const store = useStore();
        const project = computed(() => store.getters["capitals/auCapital"]);
        async function getCompanyLogo(id) {
            try {
                const resp = await store.dispatch("getCompaniesById", id);
                return resp.logoFile?.name ?? "/img/capital/aut-sign.png";
            }
            catch (e) {
                console.error(e);
            }
            return "/img/capital/aut-sign.png";
        }
        const companyLogo = ref("");
        const isAutenticProject = computed(() => process.env.VUE_APP_VENDOR == "autentic");
        const avatarLabel = computed(() => project.value.user.fName[0] + project.value.user.iName[0]);
        const userName = computed(() => {
            let fName = project.value.user.fName ?? "  ";
            fName = fName[0].toUpperCase() + fName.slice(1);
            let iName = project.value.user?.iName ?? " ";
            iName = iName[0].toUpperCase() + iName.slice(1);
            return `${fName} ${iName}`;
        });
        const userRole = computed(() => store.getters.language === "en" ? "Company president" : "Президент компании");
        onMounted(async () => {
            companyLogo.value = await getCompanyLogo(project.value.company.id);
        });
        return (_ctx, _cache) => {
            const _component_UIcon = _resolveComponent("UIcon");
            const _component_UContent = _resolveComponent("UContent");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_UContent, {
                    padding: "15px",
                    "header-align": "space-between",
                    "header-padding": "0px 0px 15px 0px"
                }, {
                    "header-left": _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                            _createVNode(_component_UIcon, {
                                class: "rounded-full",
                                icon: companyLogo.value,
                                "icon-size": "26px"
                            }, null, 8, ["icon"]),
                            _createElementVNode("div", null, _toDisplayString(project.value.company.nameEng), 1)
                        ])
                    ]),
                    default: _withCtx(() => [
                        (isAutenticProject.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[0] || (_cache[0] = [
                                    _createElementVNode("span", { class: "title" }, "Autentic DAO: Mersin LLC", -1),
                                    _createElementVNode("span", { class: "subtitle" }, "Governing body", -1)
                                ]))]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                _createVNode(UAvatar, { label: avatarLabel.value }, null, 8, ["label"]),
                                _createElementVNode("div", _hoisted_5, [
                                    _createElementVNode("span", _hoisted_6, _toDisplayString(userName.value), 1),
                                    _createElementVNode("span", _hoisted_7, _toDisplayString(userRole.value), 1)
                                ])
                            ]))
                    ]),
                    _: 1
                })
            ]));
        };
    }
});
